import { REDUCERS_NAME } from '../../constants';
import { createActionName } from '../../utility';

export const reducerName = REDUCERS_NAME.ACTIONS;

export const ACTIONS = createActionName(reducerName, 'ACTIONS');
